import useEventListener from "@use-it/event-listener";
import { useEffect, useState } from "react";
import { ImSearch } from "react-icons/im";
import axios from "../../services/axios";
import "./styles.css";
import { useFilter } from "../../hooks/useFilter";

interface SearchProps {
  type?: string;
  onClick?: (value: string | undefined) => void;
  onChange?: (value: string | undefined) => void;
}

export default function ComponentInputSearch({ type, onClick, onChange }: SearchProps) {
  const [textToSearch, setTextToSearch] = useState<string | undefined>();
  const { systemManager } = useFilter();

  useEventListener("keyup", (event: KeyboardEvent) => {
    const { key } = event;
    if (key === "Enter") onClick && onClick(textToSearch);
  });

  useEffect(() => {
    setTextToSearch("");
  }, [type]);

  useEffect(() => {
    const options = document.getElementById("search-suggestions");
    if (options) options.innerHTML = "";

    if (systemManager === "TASK_EVALUATION") {
      axios.get("/tasks/taskType")
        .then((response) => {
          const taskTypes = response.data;
          const TaskTypeEnumObj = Object.keys(taskTypes).reduce((acc, key) => {
            acc[key] = taskTypes[key];
            return acc;
          }, {} as Record<string, string>);

          if (typeof window !== "undefined" && window.localStorage) {
            localStorage.setItem("TaskTypeEnumObj", JSON.stringify(TaskTypeEnumObj));
          }

          axios.get("/tasks/summary")
            .then((response) => {
              const taskSummaries = response.data;
              const updatedTaskSummaries = taskSummaries.map((task: any) => {
                return {
                  ...task,
                  type: TaskTypeEnumObj[task.task_type],
                };
              });

              const types = Array.from(
                new Set(updatedTaskSummaries.map((task: any) => task.type))
              ).filter(Boolean) as string[];

              const userNames = Array.from(
                new Set(updatedTaskSummaries.map((task: any) => task.user_name))
              ).filter(Boolean) as string[];

              const initials = Array.from(
                new Set(updatedTaskSummaries.map((task: any) => task.initials != "" ? `${task.initials.split("-")[0]}-${task.initials.split("-")[1]}` : undefined))
              ).filter(Boolean) as string[];

              const listSummary = [...types, ...userNames, ...initials];

              if (options) {
                options.innerHTML = "";
                listSummary.forEach((item: string) => {
                  const option = document.createElement("option");
                  option.value = item;
                  options.appendChild(option);
                });
              }
            })
        });
    }
  }, [systemManager]);

  return (
    <div className="search__container">
      <input
        placeholder={`PESQUISAR${type ? ` ${type?.toLocaleUpperCase()}` : ""}...`}
        className="search__input"
        max={150}
        value={textToSearch}
        onChange={(value: any) => {
          if (onChange) onChange(value.target.value)
          setTextToSearch(value.target.value)
        }}
        autoComplete="off"
        list={"search-suggestions"}
      />
      <datalist id="search-suggestions" />

      <ImSearch
        className="search__icon"
        onClick={() => onClick && onClick(textToSearch)}
      />
    </div>
  );
}
